import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Icon } from '@scuf/common';
import Footer from './components/AppFooter/Footer';
import { authConfig } from './userManagerConfig';
import { UserManager, useUser } from '@forge/sso-client';
import { BrowserRouter as Router } from 'react-router-dom';
import ForgeWrpper from './router/ForgeWrapper';
import { KeyCloackAuthProvider, keyCloakLogout } from './router/KeyCloakWrapper';
import { isAks } from './utils/properties/UrlsAndEnvProperties';
import { AnalyticsComponent } from './utils/analytics/useAnalytics';
import ActiveUser from './components/ActiviteUser/ActiveUser';
import { TourProvider } from '@reactour/tour'
import { useTour } from '@reactour/tour'
import { useNavigate, useLocation } from "react-router-dom";
import { getCurrentRole, getGuideTour, setGuideTour } from 'src/slices/onBoardingSlice';
import { components } from '@reactour/tour';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

interface BadgeProps {
  children?: React.ReactNode; // Make children optional
}
const App = () => {
  const { setIsOpen } = useTour()

  const dispatch = useDispatch();

  const currentRole = useSelector(getCurrentRole);
  const guideTour = useSelector(getGuideTour);
  const disableBody = (target) => disableBodyScroll(target)
  const enableBody = (target) => enableBodyScroll(target)
  UserManager.createInstance(authConfig);
  interface IToastCloseButton {
    closeToast: Function;
  }

  let logoutTimeout: any;
  const userManager = UserManager.getInstance();

  /** Method to enable to close button functionality */
  const ToastCloseButton = (props: IToastCloseButton) => (
    <div className="fi-toast__default-close-button" onClick={() => props.closeToast()}><Icon name="close" root="common" size="small" /></div>
  );

  useEffect(() => {
    const events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress'
    ];
    for (var i in events) {
      window.addEventListener(events[i], resetTimeout);
    }
    setTimeoutfn();
  }, [])

  const setTimeoutfn = () => {
    logoutTimeout = setTimeout(logout, 1000 * 60 * 20);
  };

  const clearTimeoutFunc = () => {
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  const logout = () => {
    console.log('Sending a logout request to the Forge IAM...');
    isAks() ? keyCloakLogout() : userManager.signoutRedirect();
  };

  const resetTimeout = () => {
    clearTimeoutFunc();
    setTimeoutfn();
  };
  const stepsReviewer = [
    {
      selector: '.role-switch',
      content: "Click on to select the relevent role from the dropdown",
      // style: stepStyle
    },
  
  
  ]
  
    const stepsOrgowner = [
      {
        selector: '.role-switch',
        content: "Click on to select the relevent role from the dropdown",
      },
  
      {
        selector: '.Overview',
        content: 'Analyze Actions',
      },
  
      {
        selector: '.Anomalies',
        content: 'Click here to navigate to the all anomalies',
      },
  
  
      {
        selector: '.headings',
        content: 'Below are the list of latest anomalies assigned',
      },
  
    ]
  
const  Badge=({ children }: BadgeProps)=> {
  return (
    <components.Badge
    styles={{ 
      badge: (base) => ({ 
        ...base, 
       
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative', // Ensures that the offset works
      })
    }}
  >
 
      <span style={{ marginTop: '15px' }}>{children}</span>
      </components.Badge>
  )
}


useEffect(() => {
 const currentGuidetour:any = Boolean(sessionStorage.getItem("guideTour"));
 if(currentGuidetour===false)
 {
  setIsOpen(false)
 }
}, [guideTour]);

  return (
    <>
              <TourProvider steps={stepsReviewer}
               afterOpen={disableBody}
               beforeClose={enableBody}    
               styles={{
                    badge: (base) => ({ ...base, bottom: '12rem' }),
                  
                  }}
                  components={{ Badge }}
                 
                  onClickClose={() => {
                    dispatch(setGuideTour(false));
                    setIsOpen(false);
                   
                  }}

                  onClickMask={() => {
                    dispatch(setGuideTour(false));
                    setIsOpen(false);
                 

                   
                  }}

              >

      <Router>
        {isAks() ? <KeyCloackAuthProvider /> : <ForgeWrpper />}
        <Footer />
        <ActiveUser />
        <ToastContainer
          hideProgressBar={true}
          closeButton={ToastCloseButton}
          newestOnTop={true}
          draggable={true}
          position="top-right"
          toastClassName="fi-toast"
          className="fi-toast-container"
          closeOnClick={false}
        />
        <AnalyticsComponent />
      </Router>
      </TourProvider>

    </>
  );
};
export default App;
